export const truncateId = (id: string) => `${id.slice(0, 6)}...`;

export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};
